export const env = {
  apiUrl: import.meta.env.VITE_API_URL ?? "",
  userPoolId: import.meta.env.VITE_USER_POOL_ID ?? "",
  userPoolClientId: import.meta.env.VITE_USER_POOL_CLIENT_ID ?? "",
  region: import.meta.env.VITE_REGION ?? "us-east-1",
  imagesUrl: import.meta.env.VITE_IMAGES_URL ?? "",
};
